var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cul class=\"nav-list\" ng-repeat=\"requirement in vm.passwordValidationRequirements\"\u003E \u003Cli\u003E{{requirement}}\u003C\u002Fli\u003E\u003C\u002Ful\u003E";;return pug_html;};
module.exports = template;